import React from 'react';
import { PiMapPinFill } from "react-icons/pi";

import { FaPhoneVolume } from "react-icons/fa6";
import { IoIosMail } from "react-icons/io";
import LanguagesDrop from './LanguagesDrop';
import { useTranslation } from 'react-i18next';

const ContactHeader = ({dis}) => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';


  return (
      <div className={`${isRTL ? '!font-almarai' : 'font-inter'} ${dis ? 'hidden' : 'block'} ${isRTL ? 'rtl' : 'ltr'} w-full bg-primary flex justify-between items-center py-2 rounded-[12px]`}>
          <div className='w-[90%] flex justify-around'>
            <div className={`flex gap-2 items-center ${isRTL ? 'flex-row-reverse' : 'flex-row'}`}>
              <PiMapPinFill size={25} fill='#FFF' />
              <a href="https://maps.app.goo.gl/Sq9GpBJyb2CuUSm7A" target='_blank' rel='noreferrer'>        
                <h3 className='text-white text-[16px]'>{t('contact.address')}</h3>
              </a>
            </div>
            <span className='text-white flex justify-center items-center text-[20px]'>|</span>
            <div className={`flex gap-2 items-center ${isRTL ? 'flex-row-reverse' : 'flex-row'}`}>
              <FaPhoneVolume size={20} fill='#FFF' />
              <a href="tel:+212661267760">              
                <h3 className='text-white text-[16px]'>{t('contact.phone')}</h3>
              </a>
            </div>
            <span className='text-white flex justify-center items-center text-[20px]'>|</span>
            <div className={`flex gap-2 items-center ${isRTL ? 'flex-row-reverse' : 'flex-row'}`}>
              <IoIosMail size={25} fill='#FFF' />
              <a href={`mailto:${t('contact.email')}`} target='_blank' rel='noreferrer'>
                <h3 className='text-white text-[16px]'>{t('contact.email')}</h3>
              </a>
            </div>
          </div>
          <div className={`languages ${isRTL ? 'pl-3 ' : 'pr-3'} flex items-center gap-2`}>
            <LanguagesDrop w-={20} className='bg-white text-[#0F0F0F] hover:bg-[#EAE9E9]' classN='text-paragraph data-[focus]:bg-white data-[focus]:text-gray-900' classN1='bg-white' icoclass='text-primary'/>
          </div>
      </div>
  )
}

export default ContactHeader